import React from 'react'
import '../../styles/T&C.css'

const Privacy = () => {
  return (
    <div style={{padding:"20px", textAlign:"justify",
    margin:"20px"}}>
    {/* Hello world */}
    <p>
      <strong>YeloSpace</strong>
    </p>
    <p>
      <strong>PRIVACY POLICY</strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>&nbsp;</span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        YeloSpace, LLC. (together with its affiliates, successors, and assigns, “
      </span>
      <strong>YeloSpace</strong>
      <span style={{ fontWeight: 400 }}>”, “</span>
      <strong>we</strong>
      <span style={{ fontWeight: 400 }}>”, “</span>
      <strong>our</strong>
      <span style={{ fontWeight: 400 }}>”, or “</span>
      <strong>us</strong>
      <span style={{ fontWeight: 400 }}>
        ”) is committed to protecting your privacy.&nbsp; This Privacy Policy
        explains how your personal information is collected, used, and disclosed
        by YeloSpace.&nbsp; This Privacy Policy applies to our websites,
        including&nbsp;
      </span>
      <a href="http://www.yelospace.com">
        <span style={{ fontWeight: 400 }}>www.yelospace.com</span>
      </a>
      <span style={{ fontWeight: 400 }}>
        , and any other website that links to this Policy (our “
      </span>
      <strong>Sites</strong>
      <span style={{ fontWeight: 400 }}>
        ”) and our mobile apps for iPhone, Windows, or Android mobile devices
        (collectively, our “
      </span>
      <strong>Service</strong>
      <span style={{ fontWeight: 400 }}>”).&nbsp;</span>
    </p>
    <ol>
      <li>
        <strong>
          {" "}
          WHAT INFORMATION DO WE COLLECT, FROM WHAT SOURCES AND FOR WHAT PURPOSES?
        </strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        The categories of information we collect can include:&nbsp;
      </span>
    </p>
    <ul>
      <li>
        <strong>Information you provide to us directly.</strong>
        <span style={{ fontWeight: 400 }}>
          {" "}
          We may collect personal information, such as your name, phone number,
          industry role, company information, payment information, email address
          and password when you register for our Service, utilize certain aspects
          of the Service, sign up for our mailing list, or otherwise communicate
          with us.&nbsp; We may also collect any communications between you and
          YeloSpace and any other information you provide to YeloSpace, such as
          but not limited to information on the company you work for, your
          website, your photo, details about assets and postal address.&nbsp;
        </span>
      </li>
      <li>
        <strong>Data collected through the use of the Service</strong>
        <span style={{ fontWeight: 400 }}>
          .&nbsp;&nbsp;We collect information about how you use the Service, your
          actions on the Service, and content you post to the Service, including
          your interaction with others on the Service, and photos you post to the
          Service, and any content you provide through messages, emails, chat, or
          other functionalities (“
        </span>
        <strong>User Content</strong>
        <span style={{ fontWeight: 400 }}>
          ”).&nbsp;&nbsp;To share photos, we will access your device camera roll
          and camera with your permission.&nbsp;&nbsp;Please remember that
          YeloSpace may, but has no obligation to, monitor, record, and store User
          Content in order to protect your safety or the safety of other users, to
          assist with regulatory or law enforcement efforts, or to protect and
          defend our rights and property.&nbsp;&nbsp;By using the Service, you
          consent to the recording, storage, and disclosure of such communications
          you send or receive for these purposes.&nbsp;
        </span>
      </li>
      <li>
        <strong>
          Information we receive from third-party sites you connect to our
          Service.&nbsp;&nbsp;
        </strong>
        <span style={{ fontWeight: 400 }}>
          We may receive personal information about you from third parties and
          combine that with information we collect through our Service. For
          example, if you use your third-party account to connect to our Service,
          we may obtain information from your third-party account (e.g., from
          Facebook, LinkedIn or Google) to set up an account. The data we receive
          from these third-party sites is dependent upon that third party’s
          policies and your privacy settings on that third-party
          site.&nbsp;&nbsp;You should always review and, if necessary, adjust your
          privacy settings on third-party websites and services before linking or
          connecting them to our website or Service.&nbsp;
        </span>
      </li>
      <li>
        <strong>Information we receive from third parties.</strong>
        <span style={{ fontWeight: 400 }}>
          From time to time, we may receive information about you from third
          parties and other users (e.g., from your broker), such as your name,
          email and phone number. We may also collect information about you that
          is publicly available.
        </span>
      </li>
    </ul>
    <p>
      <span style={{ fontWeight: 400 }}>
        We use this information to operate, maintain, and provide to you the
        features and functionality of the Service (e.g. build and maintain a
        membership profile of your account), to connect Brokers, Buyers, Sellers,
        Lessor, Sublessor and other visitors as well as but not limited to
        communicate directly with you, such as to send you email messages to
        follow up on properties or services that we provide to you; match and
        serve targeted advertising and promotions; determine your eligibility and
        profile for certain real properties available for purchase or lease; send
        you information about topics or commercial properties that may be of
        interest to you; detect spam, malware and other malicious links or
        content; for abuse protection; and permit you to communicate with others
        on the Service.&nbsp; We may also send you Service-related emails or
        messages (e.g., account verification, change or updates to features of the
        Service, technical and security notices).&nbsp; For more information about
        your communication preferences, see “Control Over Your Information” below.
      </span>
    </p>
    <ol start={2}>
      <li>
        <strong>
          {" "}
          HOW WE USE COOKIES AND OTHER TRACKING TECHNOLOGY TO COLLECT INFORMATION.
        </strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        We, and our third-party partners, automatically collect certain types of
        usage information when you visit our Service, read our emails, or
        otherwise engage with us. &nbsp;We typically collect this information
        through a variety of tracking technologies, including cookies, web
        beacons, web pixels, embedded scripts, location-identifying technologies,
        file information, and similar technology (collectively, “
      </span>
      <strong>tracking technologies</strong>
      <span style={{ fontWeight: 400 }}>
        ”).&nbsp; For example, we collect information about your device and its
        software, such as your IP address, browser type, operating system,
        language, usage session, location of your wireless device (e.g., latitude
        and longitude), the state or country from which you accessed the Service,
        the date and time of your visit, error logs, and other such information.
        &nbsp;
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We also collect information about the way you use our Service, for
        example, the site from which you came and the site to which you are going
        when you leave our website, the pages you visit, the links you click, how
        frequently you access the Service, whether you open emails or click the
        links contained in emails, whether you access the Service from multiple
        devices, and other actions you take on the Service. &nbsp;When you access
        our Service from a mobile device, we may collect unique identification
        numbers associated with your device or our mobile application (including,
        for example, a UDID, Unique ID for Advertisers (“
      </span>
      <strong>IDFA</strong>
      <span style={{ fontWeight: 400 }}>
        ”), Google AdID, or Windows Advertising ID), mobile carrier, device type,
        model and manufacturer, mobile device operating system brand and model,
        phone number, and, depending on your mobile device settings, your
        geographical location data, including GPS coordinates (e.g., latitude
        and/or longitude) or similar information regarding the location of your
        mobile device, or we may be able to approximate a device’s location by
        analyzing other information, like an IP address.&nbsp; We may collect
        analytics data or use third-party analytics tools such as Google Analytics
        to help us measure traffic and usage trends for the Service and to
        understand more about the demographics of our users.&nbsp; You can learn
        more about Google’s practices at&nbsp;
      </span>
      <a href="http://www.google.com/policies/privacy/partners">
        <span style={{ fontWeight: 400 }}>
          http://www.google.com/policies/privacy/partners
        </span>
      </a>
      <span style={{ fontWeight: 400 }}>
        &nbsp;and view its currently available opt-out options at&nbsp;
      </span>
      <a href="https://tools.google.com/dlpage/gaoptout">
        <span style={{ fontWeight: 400 }}>
          https://tools.google.com/dlpage/gaoptout
        </span>
      </a>
      <span style={{ fontWeight: 400 }}>
        . &nbsp;We may also work with third-party partners to employ technologies,
        including the application of statistical modeling tools, which permit us
        to recognize and contact you across multiple devices. &nbsp;Although we do
        our best to honor the privacy preferences of our users, we are unable to
        respond to Do Not Track signals set by your browser at this time.&nbsp;
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We use or may use the data collected through tracking technologies
        to:&nbsp; (a) remember information so that you will not have to re-enter
        it during your visit or the next time you visit the site; (b) provide
        custom, personalized content and information, including targeted content
        and advertising; (c) recognize and contact you across multiple devices;
        (d) provide and monitor the effectiveness of our Service; (e) monitor
        aggregate metrics such as total number of visitors, traffic, usage, and
        demographic patterns on our Service; (f) diagnose or fix technology
        problems; and (g)&nbsp;otherwise to plan for and enhance our service.
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        If you would prefer not to accept cookies, most browsers will allow you
        to: (i) change your browser settings to notify you when you receive a
        cookie, which lets you choose whether or not to accept it; (ii) disable
        existing cookies; or (iii) set your browser to automatically reject
        cookies.&nbsp; Please note that doing so may negatively impact your
        experience using the Service, as some features and services on our Service
        may not work properly. Depending on your mobile device and operating
        system, you may not be able to delete or block all cookies.&nbsp; You may
        also set your email options to prevent the automatic downloading of images
        that may contain technologies that would allow us to know whether you have
        accessed our email and performed certain functions with it.&nbsp;
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We and our third-party partners may also use cookies and tracking
        technologies for advertising purposes.&nbsp; For more information about
        tracking technologies, please see “Third Party Tracking and Online
        Advertising” below.
      </span>
    </p>
    <ol start={3}>
      <li>
        <strong> SHARING OF YOUR INFORMATION</strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        We may share your personal information in the instances described
        below.&nbsp; For further information on your choices regarding your
        information, see the “Control Over Your Information” section below.
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        Remember, our Service allows you to connect and interact with
        others.&nbsp;
      </span>
      <strong>
        Your profile information, including your name, photo, and other personal
        information, will be available publicly and to other members of the
        Service&nbsp;
      </strong>
      <strong>by default</strong>
      <strong>
        &nbsp;when you create a profile, interact with others on the Service in
        public groups, and post content to public spaces.
      </strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We may share your personal information with:
      </span>
    </p>
    <ul>
      <li>
        <span style={{ fontWeight: 400 }}>
          The public and other members of the Service.&nbsp; Your profile
          information and content you post to public areas of the Service will be
          viewable by others on the Service and the public. Please do not provide
          personal information you would not want to be public.&nbsp; You may be
          able to control the visibility of some of your information in your
          Profile page (see “Control Over Your Information” below);
        </span>
      </li>
      <li>
        <span style={{ fontWeight: 400 }}>
          Other users of the Service. We share your information with third parties
          to whom you express your interest in on the Service, for example, if you
          request information on a particular asset, download document from an
          Asset’s Property Page on our Site or submit an offer on a particular
          Asset, then the seller and/or its representative will be given access to
          your information. When you log-in and visit any property on the Service,
          we also share your information, such as&nbsp;User Content you provide
          consisting of information about individual properties, including but not
          limited to information regarding title and legal status, current and
          potential valuations, physical condition and aesthetic/tenant
          improvement attributes, environmental reports, encumbrances, rent roll
          and pending lease negotiations, and tenant defaults or issues,&nbsp;with
          the broker or seller associated with that property. You control with
          whom you want to share information;&nbsp;
        </span>
      </li>
      <li>
        <span style={{ fontWeight: 400 }}>
          Third-party vendors and other service providers that perform services on
          our behalf, as needed to carry out their work for us, which may include
          payment processing services, identifying and serving targeted
          advertisements, providing mailing services, providing tax and accounting
          services, web hosting, or providing analytic services;
        </span>
      </li>
      <li>
        <span style={{ fontWeight: 400 }}>
          {" "}
          &nbsp;Other companies and brands owned or controlled by YeloSpace and
          other companies owned by or under common ownership as YeloSpace, which
          also includes our subsidiaries (i.e., any organization we own or
          control) or our ultimate holding company (i.e., any organization that
          owns or controls us) and any subsidiaries it owns.&nbsp; These companies
          will use your personal information in the same way as we can under this
          Policy;
        </span>
      </li>
      <li>
        <span style={{ fontWeight: 400 }}>
          Other parties in connection with a company transaction, such as a
          merger, sale of company assets or shares, reorganization, financing,
          change of control or acquisition of all or a portion of our business by
          another company or third party, or in the event of a bankruptcy or
          related or similar proceedings; and
        </span>
      </li>
      <li>
        <span style={{ fontWeight: 400 }}>
          Third parties as required by law or subpoena or if we reasonably believe
          that such action is necessary to (a) comply with the law and the
          reasonable requests of law enforcement; (b) to enforce our&nbsp;
        </span>
        <a href="about:blank">
          <span style={{ fontWeight: 400 }}>Terms and</span>
        </a>
        <span style={{ fontWeight: 400 }}> Conditions</span>
        <span style={{ fontWeight: 400 }}>(</span>
        <a href="https://www.yelospace.com/tac">
          <span style={{ fontWeight: 400 }}>https://www.yelospace.com/tac</span>
        </a>
        <span style={{ fontWeight: 400 }}>)&nbsp;</span>
        <span style={{ fontWeight: 400 }}>
          or to protect the security or integrity of our Service; and/or (c) to
          exercise or protect the rights, property, or personal safety of
          YeloSpace, our visitors, or others.
        </span>
      </li>
    </ul>
    <p>
      <span style={{ fontWeight: 400 }}>
        We may also share information with others in an aggregated or otherwise
        anonymized form that does not reasonably identify you directly as an
        individual.
      </span>
    </p>
    <ol start={4}>
      <li>
        <strong> CONTROL OVER YOUR INFORMATION</strong>
      </li>
    </ol>
    <p>
      <strong>Profile and Data Sharing Settings.</strong>
      <span style={{ fontWeight: 400 }}>
        &nbsp; You may update your profile information, such as your name, photo,
        industry role, address, and phone number on your Profile page, available
        at&nbsp;
      </span>
      <a href="https://www.yelospace.com/dashboard/profile">
        <span style={{ fontWeight: 400 }}>
          https://www.yelospace.com/dashboard/profile
        </span>
      </a>
      <span style={{ fontWeight: 400 }}>
        , or by contacting us at&nbsp;account@yelospace.com
      </span>
    </p>
    <p>
      <strong>How to control your communications preferences:</strong>
      <span style={{ fontWeight: 400 }}>
        &nbsp; You can stop receiving periodic newsletters, updates to our
        Services, important news in the commercial real estate industry and other
        promotional email communications from us by clicking on the “unsubscribe
        link” provided in such communications.&nbsp; We make every effort to
        promptly process all unsubscribe requests.&nbsp; You may not opt out of
        service-related communications (e.g., account verification, transactional
        communications, confirmation of offers submitted and other related
        communications, such as technical and security notices).
      </span>
    </p>
    <p>
      <strong>Modifying or deleting your information:</strong>
      <span style={{ fontWeight: 400 }}>
        &nbsp; If you have any questions about reviewing, modifying, or deleting
        your information, or if you want to remove your name or comments from our
        Service or publicly displayed content, you can visit your profile page,
        available at&nbsp;
      </span>
      <a href="https://www.yelospace.com/dashboard/profile">
        <span style={{ fontWeight: 400 }}>
          https://www.yelospace.com/dashboard/profile
        </span>
      </a>
      <span style={{ fontWeight: 400 }}>, or contact us at&nbsp;</span>
      <span style={{ fontWeight: 400 }}>account@yelospace.com</span>
      <span style={{ fontWeight: 400 }}>
        .&nbsp; We may not be able to modify or delete your information in all
        circumstances.&nbsp;
      </span>
    </p>
    <ol start={5}>
      <li>
        <strong> THIRD-PARTY TRACKING AND ONLINE ADVERTISING</strong>
      </li>
    </ol>
    <p>
      <strong>Interest-Based Advertising.&nbsp;&nbsp;</strong>
      <span style={{ fontWeight: 400 }}>
        We participate in interest-based advertising and use third-party
        advertising companies to serve you targeted advertisements based on your
        browsing history.&nbsp; We may share or we may permit third-party online
        advertising networks, social media companies, and other third-party
        services to collect information about your use of our website over time so
        that they may play or display ads on our Service, on other devices you may
        use, and on other websites, apps, or services.&nbsp; Typically, though not
        always, the information we share is provided through cookies or similar
        tracking technologies, which recognize the device you are using and
        collect information, including click stream information, browser type,
        time and date you visited the site, and other information.&nbsp; We and
        our third-party partners use this information to make the advertisements
        you see online more relevant to your interests, as well as to provide
        advertising-related services such as reporting, attribution, analytics,
        and market research.&nbsp;&nbsp;
      </span>
    </p>
    <p>
      <strong>Cross-Device Linking.&nbsp;&nbsp;</strong>
      <span style={{ fontWeight: 400 }}>
        We, or our third-party partners, may link your various devices so that
        content you see on one device can result in relevant advertising on
        another device.&nbsp; We do this by collecting information about each
        device you use when you are logged in to our Service.&nbsp; We may also
        work with third-party partners who employ tracking technologies or the
        application of statistical modeling tools to determine if two or more
        devices are linked to a single user or household.&nbsp; We may share a
        common account identifier (such as an email address or user ID) with
        third-party advertising partners to help recognize you across
        devices.&nbsp; We, and our partners, can use this cross-device linkage to
        serve interest-based advertising and other personalized content to you
        across your devices, to perform analytics, and to measure the performance
        of our advertising campaigns.
      </span>
    </p>
    <p>
      <strong>Your Choices:</strong>
    </p>
    <ul>
      <li>
        <strong>Interest-based advertising.</strong>
        <span style={{ fontWeight: 400 }}>
          To learn about interest-based advertising and how you may be able to
          opt-out of some of this advertising, you may wish to visit the Network
          Advertising Initiative’s online resources at&nbsp;
        </span>
        <a href="http://www.networkadvertising.org/choices">
          <span style={{ fontWeight: 400 }}>
            http://www.networkadvertising.org/choices
          </span>
        </a>
        <span style={{ fontWeight: 400 }}>
          &nbsp;and/or the DAA’s resources at&nbsp;
        </span>
        <a href="http://www.aboutads.info/choices">
          <span style={{ fontWeight: 400 }}>www.aboutads.info/choices</span>
        </a>
        <span style={{ fontWeight: 400 }}>.&nbsp;</span>
      </li>
      <li>
        <strong>Cross-device linking.</strong>
        <span style={{ fontWeight: 400 }}>
          Please note that opting-out of receiving interest-based advertising
          through the NAI’s and DAA’s online resources will only opt-out a user
          from receiving interest-based ads on that specific browser or device,
          but the user may still receive interest-based ads on his or her other
          devices. &nbsp;You must perform the opt-out on each browser or device
          you use.
        </span>
      </li>
      <li>
        <strong>Mobile advertising.</strong>
        <span style={{ fontWeight: 400 }}>
          {" "}
          You may also be able to limit interest-based advertising through the
          settings on your mobile device by selecting “limit ad tracking” (iOS) or
          “opt-out of interest based ads” (Android).&nbsp; You may also be able to
          opt-out of some—but not all—interest-based ads served by mobile ad
          networks by visiting&nbsp;
        </span>
        <a href="http://youradchoices.com/appchoices%20">
          <span style={{ fontWeight: 400 }}>
            http://youradchoices.com/appchoices
          </span>
        </a>
        <span style={{ fontWeight: 400 }}>
          &nbsp;and downloading the mobile AppChoices app.&nbsp;&nbsp;&nbsp;&nbsp;
        </span>
      </li>
      <li>
        <span style={{ fontWeight: 400 }}>
          Some of these opt-outs may not be effective unless your browser is set
          to accept cookies.&nbsp; If you delete cookies, change your browser
          settings, switch browsers or computers, or use another operating system,
          you will need to opt-out again.
        </span>
      </li>
    </ul>
    <p>
      <strong>Google Analytics and Advertising</strong>
      <span style={{ fontWeight: 400 }}>
        .&nbsp; We use Google Analytics to recognize you and link the devices you
        use when you visit our site or Service on your browser or mobile device,
        log in to your account on our Service, or otherwise engage with us.&nbsp;
        We share a unique identifier, like a user ID or hashed email address, with
        Google to facilitate the service.&nbsp; Google Analytics allows us to
        better understand how our users interact with our Service and to tailor
        our advertisements and content to you.&nbsp; For information on how Google
        Analytics collects and processes data, as well as how you can control
        information sent to Google, review Google's site “How Google uses data
        when you use our partners’ sites or apps” located
        at&nbsp;www.google.com/policies/privacy/partners/.&nbsp; You can learn
        about Google Analytics’ currently available opt-outs, including the Google
        Analytics Browser Ad-On here&nbsp;
      </span>
      <a href="https://tools.google.com/dlpage/gaoptout/">
        <span style={{ fontWeight: 400 }}>
          https://tools.google.com/dlpage/gaoptout/
        </span>
      </a>
      <span style={{ fontWeight: 400 }}>.</span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We may also utilize certain forms of display advertising and other
        advanced features through Google Analytics, such as Remarketing with
        Google Analytics, Google Display Network Impression Reporting, the
        DoubleClick Campaign Manager Integration, and Google Analytics
        Demographics and Interest Reporting. These features enable us to use
        first-party cookies (such as the Google Analytics cookie) and third-party
        cookies (such as the DoubleClick advertising cookie) or other third-party
        cookies together to inform, optimize, and display ads based on your past
        visits to the Service.&nbsp; You may control your advertising preferences
        or opt-out of certain Google advertising products by visiting the Google
        Ads Preferences Manager, currently available at&nbsp;
      </span>
      <a href="https://google.com/ads/preferences%20">
        <span style={{ fontWeight: 400 }}>
          https://google.com/ads/preferences
        </span>
      </a>
      <span style={{ fontWeight: 400 }}>
        , or by vising NAI’s online resources at&nbsp;
      </span>
      <a href="http://www.networkadvertising.org/choices">
        <span style={{ fontWeight: 400 }}>
          http://www.networkadvertising.org/choices
        </span>
      </a>
      <span style={{ fontWeight: 400 }}>.&nbsp;&nbsp;&nbsp;</span>
    </p>
    <ol start={6}>
      <li>
        <strong> HOW WE STORE AND PROTECT YOUR INFORMATION</strong>
      </li>
    </ol>
    <p>
      <strong>Data storage and transfer</strong>
      <span style={{ fontWeight: 400 }}>
        :&nbsp; Your information collected through our website may be stored and
        processed in the United States or any other country in which YeloSpace or
        its parent, subsidiaries, affiliates, or service providers maintain
        facilities.&nbsp; If you are located in the European Union or other
        regions with laws governing data collection and use that may differ from
        U.S. law, please note that we may transfer information, including personal
        information, to a country and jurisdiction that does not have the same
        data protection laws as your jurisdiction.&nbsp;
      </span>
    </p>
    <p>
      <strong>Keeping your information safe:</strong>
      <span style={{ fontWeight: 400 }}>
        &nbsp; We care about the security of your information and employ physical,
        administrative, and technological safeguards designed to preserve the
        integrity and security of all information collected through our
        Service.&nbsp; However, no security system is impenetrable, and we cannot
        guarantee the security of our systems 100%.&nbsp; In the event that any
        information under our control is compromised as a result of a breach of
        security, we will take reasonable steps to investigate the situation and,
        where appropriate, notify those individuals whose information may have
        been compromised and take other steps, in accordance with any applicable
        laws and regulations.
      </span>
    </p>
    <ol start={7}>
      <li>
        <strong> CHILDREN’S PRIVACY</strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        YeloSpace does not knowingly collect or solicit any information from
        anyone under the age of 13 on this Service.&nbsp; In the event that we
        learn that we have inadvertently collected personal information from a
        child under age 13, we will delete that information as quickly as
        possible.&nbsp; If you believe that we might have any information from a
        child under 13, please contact us at&nbsp;privacy@yelospace.com.&nbsp;
      </span>
    </p>
    <ol start={8}>
      <li>
        <strong> LINKS TO OTHER WEB SITES AND SERVICES</strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        The Service may contain links to and from third-party websites of our
        business partners and advertisers and our users may post links to
        third-party websites, including a variety of social networking
        sites.&nbsp; If you follow a link to any of these websites, please note
        that these websites have their own privacy policies and that we do not
        accept any responsibility or liability for their policies.&nbsp; We
        strongly recommend that you read their privacy policies and terms and
        conditions of use to understand how they collect, use, and share
        information. We are not responsible for the privacy practices or the
        content on the websites of third-party sites.
      </span>
    </p>
    <ol start={9}>
      <li>
        <strong> HOW TO CONTACT US</strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        If you have any questions about this Privacy Policy or the Service, please
        contact us at:
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>Attn: Privacy Department</span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>YeloSpace, LLC</span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>Email:&nbsp;privacy@yelospace.com</span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>Phone:&nbsp;(646) 342-2331</span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        In your message, please provide us with your name, mailing address,
        telephone number and e-mail address.
      </span>
    </p>
    <ol start={10}>
      <li>
        <strong> CHANGES TO OUR PRIVACY POLICY</strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        We may modify or update this Privacy Policy from time to time to reflect
        the changes in our business and practices, so you should review this page
        periodically.&nbsp; When we change the policy in a material manner, we
        will let you know and update the ‘last modified’ date at the top of this
        page.&nbsp; If you object to any changes, you may close your account.
      </span>
    </p>
    <ol start={11}>
      <li>
        <strong> New York Residents Only</strong>
      </li>
    </ol>
    <p>
      <span style={{ fontWeight: 400 }}>
        This portion of our Privacy Policy applies only to residents of the state
        of New York.
      </span>
    </p>
    <p>
      <strong>
        Categories of Personal Information Collected about Consumers
      </strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        In the 12-month period before the effective date this Privacy Policy,
        YeloSpace collected the following categories of personal information about
        consumers:
      </span>
    </p>
    <ul>
      <li style={{ fontWeight: 400 }}>
        <strong>Identifiers</strong>
        <span style={{ fontWeight: 400 }}>
          &nbsp;such as real name, alias, postal address, unique personal
          identifier, online identifier, Internet Protocol address, email address,
          account name, social security number, driver’s license number, passport
          number, or other similar identifiers.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Commercial information</strong>
        <span style={{ fontWeight: 400 }}>
          , such as records of personal or real property, products or services
          purchased, obtained, or considered, or other purchasing or consuming
          histories or tendencies.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Internet or other electronic network activity information</strong>
        <span style={{ fontWeight: 400 }}>
          , such as browsing history, search history, and information regarding a
          consumer’s interaction with an internet website or mobile application,
          or advertisement.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Geolocation data</strong>
        <span style={{ fontWeight: 400 }}>.</span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Professional or employment-related</strong>
        <span style={{ fontWeight: 400 }}>&nbsp;</span>
        <strong>information</strong>
        <span style={{ fontWeight: 400 }}>.</span>
      </li>
    </ul>
    <p>
      <strong>
        Categories of Sources from Which Personal Information is Collected
      </strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        YeloSpace may have collected personal information about you form the
        following categories of sources:
      </span>
    </p>
    <ul>
      <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>Directly from you.</span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>From your use of the Service.</span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
          Information we receive from third-party sites you connect to our
          Service.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>
          Other companies, such as our service providers and vendors.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <span style={{ fontWeight: 400 }}>Government entities and records.</span>
      </li>
    </ul>
    <p>
      <strong>
        Business or Commercial Purpose for Collecting Personal Information from
        Consumers
      </strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        YeloSpace may have collected personal information for any of the business
        or commercial purposes set forth in Section 1 of this Privacy Policy.
      </span>
    </p>
    <p>
      <strong>Sharing and Selling of Personal Information</strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We&nbsp;may “sell” or “share” your personal information in two ways.
        First, as described in our Terms of Service, you may share and/or receive
        personal information on the platform depending on your subscription type.
        You may opt out of such disclosures by emailing us
        at&nbsp;privacy@yelospace.com.
      </span>
      <span style={{ fontWeight: 400 }}>
        <br />
        <br />
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        Second, we may allow certain third parties (such as online advertising
        services) to collect your personal information via automated technologies
        on our Site and Services in exchange for non-monetary consideration. We
        share the categories of personal information listed below for the business
        and commercial purposes of online advertising and to provide third-party
        social network features and functionality on our Site and Services. Those
        third parties may use your personal information for optimization, display
        cross-contextual advertising and manage their own platforms. You have the
        right to opt out of this disclosure of your information, which may be
        considered a “sale” or “sharing” under New York law, as set forth below.
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        During the 12-month period prior to the effective date of this Privacy
        Policy, we may have sold or shared the following categories of personal
        information:
      </span>
    </p>
    <table>
      <tbody>
        <tr>
          <td>
            <p>
              <strong>Category of Personal Information</strong>
            </p>
          </td>
          <td>
            <p>
              <strong>Category of Third Party</strong>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>&nbsp;Identifiers</span>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                &nbsp;Platform subscribers, advertising networks, data analytics
                providers, social networks, data brokers, operational software
                providers and vendors
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>Commercial Information</span>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Advertising networks, data analytics providers, social networks,
                data brokers, platform subscribers, operational software providers
                and vendors
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Online Activity and Geolocation Data
              </span>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Advertising networks, data analytics providers, social networks,
                data brokers, platform subscribers, operational software providers
                and vendors
              </span>
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Professional or employment-related information
              </span>
            </p>
          </td>
          <td>
            <p>
              <span style={{ fontWeight: 400 }}>
                Operational software providers and vendors, advertising networks,
                data analytics providers, social networks, data brokers
              </span>
            </p>
          </td>
        </tr>
      </tbody>
    </table>
    <p>
      <span style={{ fontWeight: 400 }}>
        We do not knowingly sell or share the personal information of minors under
        16 years of age.
      </span>
      <span style={{ fontWeight: 400 }}>
        <br />
        <br />
      </span>
    </p>
    <p>
      <strong>
        Categories of Personal Information Disclosed to Third Parties
      </strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We share all the categories of personal information that we collect for
        the purposes listed in the “Sharing of Personal Information” section
        above.
      </span>
    </p>
    <p>
      <strong>Retention</strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        We retain the personal information that we collect to achieve the purposes
        for which the personal information was collected. In certain cases, we may
        need to retain personal information for purposes required under applicable
        law, for tax or audit purposes, or for other purposes permitted under law.
      </span>
    </p>
    <p>
      <strong>CCPA Rights</strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        If you are a California resident, you have the following rights regarding
        your personal information:
      </span>
    </p>
    <ul>
      <li style={{ fontWeight: 400 }}>
        <strong>Right to Know:</strong>
        <span style={{ fontWeight: 400 }}>
          &nbsp;The right to know what personal information we have collected
          about you, including the categories of personal information, the
          categories of sources form which the personal information is collected,
          the business or commercial purpose for collecting, selling, or sharing
          such personal information, the categories of third parties to whom we
          have disclosed personal information, and the specific pieces of personal
          information that we have collected about you.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Right to Delete</strong>
        <span style={{ fontWeight: 400 }}>
          : Subject to certain exceptions, the right to delete personal
          information that we have collected from you.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Right to Correct Inaccurate Personal Information</strong>
        <span style={{ fontWeight: 400 }}>
          : The right to correct inaccurate personal information that we maintain
          about you.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Right to Opt-Out of Sale or Share</strong>
        <span style={{ fontWeight: 400 }}>
          : The right to opt-out of the sale or sharing of your personal
          information by us.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>
          Right to Limit Disclosure of Sensitive Personal Information:
        </strong>
        <span style={{ fontWeight: 400 }}>
          &nbsp;We use sensitive personal information, if at all, for the limited
          purposes set forth below: (1) performing our service or providing goods,
          (2) detecting security incidents, (3) resisting malicious, deceptive,
          fraudulent, or illegal actions, (4) ensuring physical safety, (4) for
          short-term transient use, including certain non-personalized
          advertising, (5) maintaining or servicing accounts, providing customer
          service, verifying customer information, or providing similar services,
          and (6) to verify and maintain the quality or safety of a service or
          product to improve, upgrade, or enhance a service or product. As such,
          there is no right to limit our use of sensitive personal information.
        </span>
      </li>
      <li style={{ fontWeight: 400 }}>
        <strong>Right to Not Receive Discriminatory Treatment</strong>
        <span style={{ fontWeight: 400 }}>
          : You have the right to not receive discriminatory treatment by us for
          the exercise of any of the rights conferred by the CCPA in this section.
        </span>
      </li>
    </ul>
    <p>
      <strong>How to Exercise Your CCPA Rights</strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        You can exercise any of your CCPA rights described in the previous section
        through the forms by emailing us at&nbsp;privacy@yelospace.com
      </span>
      <span style={{ fontWeight: 400 }}>.</span>
      <span style={{ fontWeight: 400 }}>&nbsp;</span>
    </p>
    <p>
      <strong>Authorized Agents</strong>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>
        You may designate an authorized agent to submit requests on your behalf.
        To submit a request as an authorized agent on behalf of a consumer, please
        contact us by emailing privacy@yelospace.com
      </span>
    </p>
    <p>
      <span style={{ fontWeight: 400 }}>&nbsp;</span>
    </p>
    <p>
      <br />
      <br />
    </p>
  </div>
  
  )
}

export default Privacy